import React from 'react';
import { connect } from 'react-redux';
import handleViewport from 'react-in-viewport';
import { propExistsAndNonEmpty } from '../../../../util/utils';
import { eventByType } from '../../../../api/eventsApi';
import tagular from '../../../../util/tagular';
import { getSortStrategy } from '../../../../strategies/sortStrategies/sortStrategyFactory';
import ResultCardItem from './resultCardItem/resultCardItem';

import './resultIndex.scss';

class ResultIndex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showAllResults: false,
            showAllResultsABTest: false
        };

        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
    }

    componentDidMount() {
        this.runShowAllResultsAbTest();
    }

    componentDidUpdate(prevProps) {
        if (this.props.filteredResults !== prevProps.filteredResults) {
            this.setState({ showAllResults: false });
        }
    }

    handleShowMoreClick(e) {
        this.setState({ showAllResults: true });

        const { assessment, inlineParentMetadata } = this.props;

        eventByType('show-all-results', assessment.id, { inlineParentMetadata });

        tagular.sendElementClickedEvent(e, {
            assessmentName: assessment.internalName,
            action: 'EXPAND'
        });
    }

    toggleButtonDisplay() {
        let display = 'show';

        if (this.state.showAllResults) {
            display = 'hide';
        }

        return display;
    }

    // applying AB test using preamp
    runShowAllResultsAbTest() {
        if (
            window._Preamp &&
            window._Preamp.actions &&
            window._Preamp.actions.placements.find(
                placement => placement.assetName === 'hide show all button'
            )
        ) {
            this.setState({ showAllResultsABTest: true });
        }
    }

    render() {
        const { filteredResults, selectedFilters, assessment } = this.props;

        let topResults;
        let additionalResults;
        if (propExistsAndNonEmpty(filteredResults)) {
            const sort = getSortStrategy(assessment.resultsConfig);
            const sorted = sort(filteredResults, selectedFilters);

            const results = sorted.map((result, idx) => {
                const ViewportResultCardItem = handleViewport(ResultCardItem);
                return <ViewportResultCardItem key={idx} assessment={assessment} result={result} />;
            });

            const { defaultDisplayCount } = assessment.resultsConfig;

            topResults = results.slice(0, defaultDisplayCount);
            additionalResults = results.slice(defaultDisplayCount);
        }

        return (
            <ul className="results-display">
                {topResults}

                {(this.state.showAllResults || this.state.showAllResultsABTest) &&
                    additionalResults}

                {!this.state.showAllResults &&
                    !this.state.showAllResultsABTest &&
                    additionalResults.length > 0 && (
                        <div
                            className="show-more-container button-container"
                            onClick={e => this.handleShowMoreClick(e)}
                        >
                            <button className="show-more-button" type="button">
                                SHOW ALL RESULTS
                            </button>
                        </div>
                    )}
            </ul>
        );
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        filteredResults: state.session.filteredResults,
        selectedFilters: state.session.selectedFilters.inResults,
        inlineParentMetadata: state.inline.parentMetadata
    };
};

export default connect(mapStateToProps, null)(ResultIndex);
